/*
 * Copyright (c) 2018. keni <$email>
 *
 * This file maps.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * maps.js can not be copied and/or distributed
 * without the express permission of keni
 */

/**
 * Display all car parks on the map
 * Created by keni on 24/07/2017.
 */

import {deBounce} from './debounce';
import {readThemeColor} from '../theme';
import {scrollTo} from './scroll-target';

/**
 *
 */
export function pushSoldToBottom() {
	$('.map-results-data[map-data-ticket-sold-out="true"]').each(function () {
		let cloneElm = $(this);

		$('#card-list').append(cloneElm);
	});

	$('.mobile__maps[map-data-ticket-sold-out="true"]').each(function () {
		let cloneElm = $(this);
		$('#mobile__maps').append(cloneElm);
	});
}

/**
 * Listens for hovering over a marker
 */
export function markerTargetHover() {
	// console.log('test');
	let markerTargetHover = (function () {
		function hoverElm(elm, out) {
			// console.log('hover', elm);
			let targetId = elm.data('marker-target');

			if (typeof targetId !== 'undefined' && targetId != false) {
				let targetElm = $(`[data-marker-target-id='${targetId}']`);

				if (out === true) {
					targetElm.removeClass('maps--marker--content-active');
				}
				else {
					targetElm.addClass('maps--marker--content-active');
				}
			}
		}

		function watcher() {
			$('.map-results-data').hover(function () {
				hoverElm($(this), false);
			}, function () {
				hoverElm($(this), true);
			});
		}

		return {
			init: function () {
				watcher();
			}
		};
	})();
	markerTargetHover.init();
}

/**
 *
 * @param opt
 */
export function toggleView(opt) {
	let toggleView;

	// console.log('Loading maps toggleView');
	toggleView = (function () {
		function hideToggles() {
			$('.toggle--view').each(function () {
				let targetId = $(this).attr('data-toggle-id'),
					targetElement = $('#' + targetId);
				targetElement.addClass('hide');
				$(this).removeClass('toggling_view');

			});
		}

		return {
			init: function () {
				$('.toggle--view').click(function (e) {
					e.preventDefault();
					hideToggles();
					let targetId = $(this).attr('data-toggle-id'),
						targetElement = $('#' + targetId);

					if (targetElement.hasClass('hide')) {
						targetElement.removeClass('hide');
						$(this).addClass('toggling_view');
					}
					else {
						targetElement.addClass('hide');
						$(this).removeClass('toggling_view');
					}
				});
			}
		};
	})();
	toggleView.init();
}

/**
 * @link http://humaan.com/custom-html-markers-google-maps/
 * @param opt
 */
export function setDirections(opt) {

	let setDirections;

	setDirections = (function () {

		// noinspection JSUnresolvedFunction,JSUnresolvedVariable
		let debugging = false,
			map,
			mapStyle = [
				{
					"featureType": "landscape.man_made",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#dfdfdf"
						}
					]
				},
				{
					"featureType": "landscape.natural",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#b3cfa4"
						},
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "poi.attraction",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.business",
					"elementType": "geometry",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.business",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#001631"
						}
					]
				},
				{
					"featureType": "poi.business",
					"elementType": "labels.text",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.business",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#0072ff"
						}
					]
				},
				{
					"featureType": "poi.government",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#69ac42"
						}
					]
				},
				{
					"featureType": "poi.place_of_worship",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.school",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.sports_complex",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#33938e"
						},
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "poi.sports_complex",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"saturation": -5
						}
					]
				},
				{
					"featureType": "poi.sports_complex",
					"elementType": "labels.icon",
					"stylers": [
						{
							"saturation": -5
						},
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "poi.sports_complex",
					"elementType": "labels.text",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.sports_complex",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#f8fffa"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#62abff"
						},
						{
							"visibility": "on"
						}
					]
				}
			],
			mapOptions = {
				// rotateControl: true,
				// fullscreenControl: true,
				// center: new google.maps.LatLng(centerPoint.lat, centerPoint.long),
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				styles: mapStyle,

				// disableDefaultUI: true

			},
			animationOptions = {
				panMap: true
			},
			latitudeLngBounds,
			markers = [],
			mapMarkerIds = [],
			cardTargetPrefix = 'card_top_',
			cardActiveClass = 'map-results-data-active',
			cardForcedTrigger = cardActiveClass + '-trigger',
			infoWindowPosition = {
				h: 20, // horizontal = x
				v: 50  // vertical = y
			},
			centerPoint = {
				lat: 52.4552018, long: -1.4989871
			},
			// eslint-disable-next-line no-use-before-define
			directionsService = new google.maps.DirectionsService, // eslint-disable-line no-use-before-define
			directionsDisplay = new google.maps.DirectionsRenderer,// eslint-disable-line no-use-before-define
			targetArena = $('#map_canvas').data('map-center'),
			// currentSelected = {},
			resultsListButtonOpen = {},
			resultsListButtonClose = {},
			directionsButtonOpen = {},
			directionsButtonClose = {},
			previousInfoWindow = false,
			previousMarker = false,
			primaryColor = $('#site-theme-color-primary').css('backgroundColor'),
			lastReference = {}
		;

		function CustomMarker(latlng, map, args) {
			this.latlng = latlng;
			this.args = args;
			this.setMap(map);
		}

		CustomMarker.prototype = new google.maps.OverlayView();

		CustomMarker.prototype.draw = function () {

			var self = this;

			var div = this.div;

			if (!div) {

				div = this.div = document.createElement('div');
				//noinspection JSUnresolvedFunction
				let point = this.getProjection().fromLatLngToDivPixel(this.latlng),
					pointWidth = 10,
					pointHeight = 30;

				div.className = 'marker';

				div.style.position = 'absolute';
				div.style.cursor = 'pointer';
				div.style.width = '0';
				div.style.height = '0';
				div.style.borderLeft = pointWidth + 'px solid transparent';
				div.style.borderRight = pointWidth + 'px solid transparent';
				div.style.borderTop = pointHeight + 'px solid ' + primaryColor;
				div.style.left = (point.x - pointWidth) + 'px';
				div.style.top = (point.y - pointHeight) + 'px';
				// div.style.background = 'blue';
// 				var content = document.createElement('div');
// 				content.innerHtml= `
// <div class="maps--marker--content-test">
// 	<div class="maps--marker--content-label">P1</div>
// 	<div class="maps--marker--content-price"></div>
// </div>`;
// 				div.appendChild(content);

				if (typeof(self.args.marker_id) !== 'undefined') {
					div.dataset.marker_id = self.args.marker_id;
				}

				google.maps.event.addDomListener(div, "click", function (event) {
					google.maps.event.trigger(self, "click");
				});

				var panes = this.getPanes();
				panes.overlayImage.appendChild(div);
			}
		};

		CustomMarker.prototype.remove = function () {
			if (this.div) {
				this.div.parentNode.removeChild(this.div);
				this.div = null;
			}
		};

		CustomMarker.prototype.getPosition = function () {
			return this.latlng;
		};

		function removeActiveTriggers() {
			$('.map-results-data-active').removeClass('map-results-data-active', 'map-results-data-active-trigger')
		}

		function referenceAction(elm, scroll) {
			let reference = elm.attr('data-marker-id-raw');
			// console.log('reference', reference,'scroll',scroll);
			if (typeof reference !== 'undefined' && reference !== false) {
				if (lastReference == reference) {
					return;
				}
				google.maps.event.trigger(markers[reference], 'click');
				lastReference = reference;
				// console.log('rolling',(scroll !== undefined));
				let isMobile = $('#site-screen-mobile').is(':visible');

				if (isMobile) {
					scrollTo($(window), 0.2, $('#map_canvas'));
				}
			}
		}

		function referenceClick() {

			$('.map-results-data').click(function () {
				referenceAction($(this));
			});
		}

		function closeButtonStyle(iwCloseBtn) {
			let css = {
				//opacity: 0.7,
				//right: 38,
				//top: 3,
				//height: 13,
				//width: 13,
				//backgroundColor: primaryColor,
				////border: '7px solid ' + primaryColor,
				//'-webkit-border-radius': 13,
				//'-moz-border-radius': 13,
				//borderRadius: 13,

				opacity: '1', // by default the close button has an opacity of 0.7
				right: '-12px', top: '3px', // button repositioning
				border: '7px solid ' + primaryColor, // increasing button border and new color
				'border-radius': '13px', // circular effect
				'box-shadow': '0 0 10px ' + readThemeColor('mid-grey', 0.5) // 3D effect to highlight the button
			};

			iwCloseBtn.css(css);
			$('#' + iwCloseBtn.attr('id') + ' + img').css({
				right: '-12px', top: '3px'
			});
			// console.log('iwCloseBtn', iwCloseBtn.attr('id'));

		}

		function createMarkerTemplate(location, locations, price, i) {
			let noDetailsBox = ($('#map_canvas').hasClass('map_canvas-no-details')) ? 'maps--marker--content-no-details' : '';
// console.log('noDetailsBox',noDetailsBox);
			return `
<div class="maps--marker--content ${noDetailsBox}"
data-marker-target-id="maps--marker-id-${location['range_id']}"
data-id="maps--marker-id-${location['range_id']}"
data-maps-target-id="${location['entity']}">
	<div class="maps--marker--content-label">
		${locations[i]['range_id']}
	</div>
	${price}
</div>`;
		}

		function createPriceMarker(priceMarker, price) {
			return `<div class="maps--marker--content-price" id="${priceMarker}">${price}</div>`
		}

		function initializeMaps() {

			// debug options
			// console.log('mapOptions',mapOptions);
			if (markers.length <= 1) {
				mapOptions.zoom = 14;
				// console.log('setting zoom',mapOptions.zoom);
			}
			map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);
		}

		/**
		 * Set up the map for use
		 */
		function setMarkers() {
			let setLocations = {};

			if (typeof setLocations !== 'undefined' && setLocations !== false) {
				setLocations = locations;
			}
			let numOfMarkers = setLocations.length;

			for (let i = 0; i < numOfMarkers; i++) {
				if (debugging) {
					console.warn('debugging enabled');
				}

				//noinspection JSUnresolvedFunction,JSUnresolvedVariable
				let price = '',
					priceMarker = '',
					markerTemplateHTML = document.createElement('div'),
					location = setLocations[i],
					mapsMarkerId = `maps--marker-id-${location['range_id']}`,
					myLatitudeLong = new google.maps.LatLng(location['lat'], location['long']),
					myMarker = markers[i];

				//console.log('mapsMarkerId', mapsMarkerId);
				mapMarkerIds.push(`#${mapsMarkerId}`);

				if (location['price'] !== null) {
					priceMarker = `price-marker-${setLocations[i]['entity']}`;
					price = createPriceMarker(priceMarker, setLocations[i]['price']);
				}

				// noinspection JSUnresolvedFunction
				markerTemplateHTML.innerHTML = createMarkerTemplate(location, setLocations, price, i);
//console.log('maps--marker-id-${location[range_id]}',`maps--marker-id-${location['range_id']}`);
				// noinspection JSUnresolvedFunction
				myMarker = new MarkerWithLabel({
					// myMarker = new google.maps.Marker({
					position: myLatitudeLong,
					map: map,
					//icon: image,
					//shape: shape,
					labelTitle: location['name'],
					labelContent: markerTemplateHTML,
					labelAnchor: new google.maps.Point(infoWindowPosition.h, infoWindowPosition.v),
					labelClass: 'maps-marker', // the CSS class for the label
					labelInBackground: false,
					html: location['html'],
					id: i
				});

				// add marker to markers array
				markers[i] = myMarker;

				// Add the position to the bounds so that we can center zoom the whole maps
				latitudeLngBounds.extend(myMarker.position);

				watchMarkersMouseOut(myMarker);
				//
				watchMarkerMouseOver(myMarker);
				//
				watchMarkerClick(myMarker);

			}
		}

		function createStaticMarkers() {
// console.log('stadiums',stadiums);
			if (typeof stadiums === 'undefined' && stadiums === false) {
				return false;
			}

			let setLocations = stadiums,
				numOfMarkers = setLocations.length;

			for (let i = 0; i < numOfMarkers; i++) {
				let location = setLocations[i],
					image = {
						url: location['icon'],
						// size: new google.maps.Size(80,80),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(30, 60),
						scaledSize: new google.maps.Size(60, 60)
					};
				let myLatitudeLong = new google.maps.LatLng(location['lat'], location['long']),
					marker = new MarkerWithLabel({
						position: myLatitudeLong,
						map: map,
						labelContent: location['title'],
						labelAnchor: new google.maps.Point(50, 100),
						labelClass: "maps__stadium-marker",
						icon: image
					});
				latitudeLngBounds.extend(marker.position);
			}
		}

		function reloadMarkers() {
			deBounce(function () {
				let i = 0;
				// Loop through markers and set map to null for each
				for (i; i < markers.length; i++) {
					markers[i].setMap(null);
				}

				// Reset the markers array
				markers = [];
				// Call set markers to re-add markers
				setMarkers();
			}, 100);
		}

		function initializeMapsWatchers() {
			google.maps.event.addListener(map, 'zoom_changed', function () {
				reloadMarkers();
				// console.log('map.getZoom()', map.getZoom());
			});
			//noinspection JSUnresolvedFunction
			directionsDisplay.setMap(map);
			//noinspection JSUnresolvedFunction
			directionsDisplay.setPanel(document.getElementById('map_directions'));
			//Get the boundaries of the Map.

			//Center map and adjust Zoom based on the position of all markers.
			//noinspection JSUnresolvedFunction
			map.setCenter(latitudeLngBounds.getCenter());

			// force maps to zoom into the markers
			// console.log('numOfMarkers',markers.length,'latitudeLngBounds',latitudeLngBounds);
			if (markers.length > 1) {
				map.fitBounds(latitudeLngBounds);
				// console.log('zooming in');

			}
			//noinspection JSUnresolvedFunction
			// map.fitBounds(latitudeLngBounds);
		}

		function readTargetMarkerDataId(elm) {
			let itemLabel = elm[0]['labelContent'],
				contentDiv = $(itemLabel).find('div'),
				content = $(contentDiv[0]);

			return {
				highlight_target: content,
				reference_id: content.attr('data-maps-target-id')
			};
		}

		function calculateAndDisplayRoute(directionsService, directionsDisplay) {
			directionsService.route({
				origin: document.getElementById('selected_car_park').value,
				destination: targetArena,
				travelMode: 'WALKING'
			}, function (response, status) {
				if (status === 'OK') {
					directionsDisplay.setDirections(response);
// console.log('response',response);
				}
				else {
					window.alert('Directions request failed due to ' + status);
				}
			});
		}

		function styleArrow(elements) {
			// Moves the shadow of the elements.arrow 76px to the left margin
			elements.arrowShadow.attr('id', 'iw-arrow-shadow');

			// Moves the elements.arrow 76px to the left margin
			elements.arrow.attr('id', 'iw-arrow');
		}

		/**
		 * Changes the desired color for the tail outline.
		 * The outline of the tail is composed of two descendants of div which contains the tail.
		 * The .find('div').children() method refers to all the div which are direct descendants of the
		 * previous div.
		 * @param elements
		 */
		function styleTail(elements) {
			elements.tailDiv.attr('id', 'iw-tail');
			elements.tailDiv.css({
				'z-index': '1'
			});
		}

		/**
		 * Big daddy click on marker and display custom info windows
		 * @param myMarker
		 */
		function watchMarkerClick(myMarker) {
			//noinspection JSUnresolvedVariable
			google.maps.event.addListener(myMarker, 'click', function () {
				$('.maps--marker--content-active').removeClass('maps--marker--content-active');

				let dataTargetObject = readTargetMarkerDataId($(this)),
					dataTarget = '#' + cardTargetPrefix + dataTargetObject.reference_id;

				removeActiveTriggers();
				$(dataTarget).addClass(cardActiveClass).addClass(cardForcedTrigger);

				let infoWindow = new google.maps.InfoWindow({
						id: this.id,
						content: this.html,
						position: this.getPosition(),
						maxWidth: 350
					}),
					markerPosition = myMarker.getPosition();

				if (previousInfoWindow) {
					// console.log('setting markers visible');
					previousInfoWindow.close();
					markers[previousMarker].setVisible(true);
				}
				/**
				 * Hide the marker before showing the info window
				 */
				this.setVisible(false);
				/**
				 * Open the info window
				 */
				infoWindow.open(map);
				let iwOuter = $('.gm-style-iw');

				// iwOuter.hide();

				// for caching so we can close the previous when opening not via the map but a click button
				previousInfoWindow = infoWindow;
				previousMarker = this.id;

				google.maps.event.addListenerOnce(infoWindow, 'closeclick', function () {
					removeActiveTriggers();
					markers[previousMarker].setVisible(true);
					// map.setCenter(latitudeLngBounds.getCenter());
				});

				// console.log('iwOuter', iwOuter);
				google.maps.event.addListener(infoWindow, 'domready', function () {
					// console.log('window open');
					// Reference to the DIV which receives the contents of the infowindow using jQuery

					/* The DIV we want to change is above the .gm-style-iw DIV.
					 * So, we use jQuery and create a iwBackground variable,
					 * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
					 */

					let iwBackground = iwOuter.prev(),
						elements = {
							shadowDiv: iwBackground.children(':nth-child(2)'),
							whiteBackground: iwBackground.children(':nth-child(4)'),
							arrow: iwBackground.children(':nth-child(3)'),
							arrowShadow: iwBackground.children(':nth-child(1)'),
							tailDiv: iwBackground.children(':nth-child(3)').find('div').children()
						};

					// Remove the background shadow DIV
					elements.shadowDiv.css({'display': 'none'});

					// Remove the white background DIV
					elements.whiteBackground.css({'display': 'none'});

					// Moves the infowindow 115px to the right.
					iwOuter.parent().parent().attr('id', 'iw').css({left: '150px'});

					// Taking advantage of the already established reference to
					// div .gm-style-iw with iwOuter variable.
					// You must set a new variable iwCloseBtn.
					// Using the .next() method of JQuery you reference the following div to .gm-style-iw.
					// Is this div that groups the close button elements.
					let iwCloseBtn = iwOuter.next();

					iwCloseBtn.attr('id', 'iw-close-button');
					closeButtonStyle(iwCloseBtn);

					// The API automatically applies 0.7 opacity to the button after the mouseout event.
					// This function reverses this event to the desired value.
					iwCloseBtn.mouseout(function () {
						$(this).css({opacity: '1'});
					});

					// console.log('iwOuter', iwOuter, iwOuter.find(">:first-child"));

					iwOuter.addClass('gm-style-iw--350');
					iwOuter.parent().addClass('gm-style-iw--350');
					iwOuter.find(">:first-child").addClass('gm-style-iw--350');
// iwOuter.find(">:first-child").css({
// 	// maxWidth:350,
// 	width:350
// });

					styleArrow(elements);

					// Changes the desired color for the tail outline.
					// The outline of the tail is composed of two descendants of div which contains the tail.
					// The .find('div').children() method refers to all the div which are direct descendants of the
					// previous div.
					styleTail(elements);

				});
				// console.log($('#card-list'), 'dataTarget', dataTarget, $(dataTarget));

				//console.log('dataTargetId', dataTargetId);
				iwOuter.addClass('gm-style-iw-350');

				if (animationOptions.panMap) {
					if (debugging) {
						console.log('animating map position to markerPosition:', markerPosition.lat);
					}
					map.panTo(markerPosition);
				}

				scrollTo($('#card-list'), 0.5, dataTarget);
			});
		}

		/**
		 * Watches mouse over events for the marker
		 * @param myMarker
		 */
		function watchMarkerMouseOver(myMarker) {
			myMarker.addListener('mouseover', function () {
				let dataTargetObject = readTargetMarkerDataId($(this)),
					dataTarget = '#' + cardTargetPrefix + dataTargetObject.reference_id;

				//console.log('dataTarget',dataTarget);
				scrollTo($('#card-list'), 0.5, dataTarget);
				$(dataTarget).addClass(cardActiveClass);
				$(dataTargetObject.highlight_target).addClass('maps--marker--content-active');
			});
		}

		/**
		 * Watches mouseout events for the marker
		 * @param myMarker
		 */
		function watchMarkersMouseOut(myMarker) {
			myMarker.addListener('mouseout', function () {
				let dataTargetId = readTargetMarkerDataId($(this)),
					referenceTargetId = '#' + cardTargetPrefix + dataTargetId.reference_id,
					hasForcedTarget = $(referenceTargetId).hasClass(cardForcedTrigger);

				if (!hasForcedTarget) {
					//$(referenceTargetId).removeClass(cardActiveClass);
					removeActiveTriggers();

					$(dataTargetId.highlight_target).removeClass('maps--marker--content-active');
				}
			});
		}

		function watcher() {
			let directionsToggle = $('.directions-toggle'),
				directionsWrapper = $('.directions-wrapper'),
				mapResults = $('.map-results'),
				resultsListButton = $('.results-toggle'),
				directionsButton = directionsToggle;

			// directions button was clicked
			$('.view-directions').click(function (e) {
				let value = $(this).val();

				e.cancelBubble = true;
				if (e.stopPropagation) {
					e.stopPropagation();
				}
				e.preventDefault();

				directionsToggle.show();

				$('#selected_car_park').val(value);
				directionsToggle
					.find('.open')
					.show();
				directionsToggle
					.find('.closed')
					.hide();
				directionsWrapper.addClass('opened');
				mapResults
					.addClass('directions-open')
					.addClass('results-open');
				$('html, body').animate({
					scrollTop: $('#map_canvas').offset().top
				}, 500);

				calculateAndDisplayRoute(directionsService, directionsDisplay);
				// removeActiveTriggers();
			});
			resultsListButtonOpen = resultsListButton.find('.open');
			resultsListButtonClose = resultsListButton.find('.closed');
			directionsButtonClose = directionsButton.find('.closed');
			directionsButtonOpen = directionsButton.find('.open');

			resultsListButtonClose.click(function () {
				mapResults.addClass('results-open');
			});
			resultsListButtonOpen.click(function () {
				mapResults.removeClass('results-open').removeClass('directions-open');
				directionsButtonOpen.click();
			});
			directionsButtonOpen.click(function () {
				$(this).hide();
				directionsButtonClose.show();
				mapResults.removeClass('directions-open');
				directionsWrapper.removeClass('opened');
			});
			directionsButtonClose.click(function () {
				$(this).hide();
				directionsButtonOpen.show();
				mapResults.addClass('directions-open').addClass('results-open');
				directionsWrapper.addClass('opened');
			});

			$('.car-park-more-button').click(function () {
				directionsWrapper.removeClass('opened');
				directionsToggle.hide();
			});
		}

		return {
			init: function () {
				latitudeLngBounds = new google.maps.LatLngBounds();
				initializeMaps();
				setMarkers();
				initializeMapsWatchers();
				watcher();
				referenceClick();
				createStaticMarkers();
			}
		};
	})();
	setDirections.init();
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/maps.js